module.exports = __webpack_public_path__ + "static/media/logo_primary-black.66166284.svg";